import { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { FormRenderer } from "./renderer/form-renderer";
import "./inline-form-host.scss";
import { datasetFormRequest, inlineFormHosts } from "./dataset-form-signal";
import type { DatasetFormRequest } from "./dataset-form-modal";

/**
 * The right pane of a split page (PageSpec.layout "split"): renders the form a
 * page opens in place, beside the table, instead of in a dialog. While mounted it
 * claims datasetFormRequest, so DatasetFormModal stays closed.
 */
export const InlineFormHost: React.FC<{ emptyMessage?: string }> = ({ emptyMessage }) => {
  const [req, setReq] = useState<{ n: number; props: DatasetFormRequest } | undefined>();

  useEffect(() => {
    inlineFormHosts.next(inlineFormHosts.value + 1);
    let n = 0;
    const sub = datasetFormRequest.subscribe((r) => {
      n += 1;
      setReq(r ? { n, props: r } : undefined);
    });
    return () => {
      sub.unsubscribe();
      inlineFormHosts.next(Math.max(0, inlineFormHosts.value - 1));
      datasetFormRequest.next(undefined);
    };
  }, []);

  if (!req) {
    return emptyMessage ? (
      <Typography color="text.secondary" sx={{ p: 2 }}>
        {emptyMessage}
      </Typography>
    ) : null;
  }
  // Keyed per request: opening another row's form starts from its own values.
  return (
    <div className="inline-form-host">
      <FormRenderer
        key={req.n}
        {...req.props}
        onCancel={req.props.onCancel ?? (() => datasetFormRequest.next(undefined))}
      />
    </div>
  );
};
